import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Función para obtener los modelos de tarjeta de emergencia activos para lista desplegable.
 */
export async function getModelos({commit, state}) {
  commit('dashboard/load', true, {root: true});
  await $http.get('/modelos_te_activos')
    .then((response) => {
      commit('dashboard/load', false, {root: true});
      commit('setModelos', response.data.data);
      state.error = false;
    })
    .catch((error) => {
      commit('dashboard/load', false, {root: true});
    });
}

/**
 * Función para obtener el modelo de tarjeta de emergencia parametrizado para la generales consultada.
 * @param int id Id de la generales consultada
 */
export async function getTarjetasEmergencia({commit, state}, id) {
  if (id !== undefined) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`/empresas/modelo_te/ver/${id}`)
      .then((response) => {
        commit('dashboard/load', false, {root: true});
        commit('setTarjetasEmergencia', response.data.data);
        state.error = false;
      })
      .catch((error) => {
        commit('dashboard/load', false, {root: true});
        commit('resetdefaultTarjetasEmergencia');
      });
  }
}

/**
 * Función para guardar o actualizar el modelo de tarjeta de emergencia parametrizado para la generales consultada
 * @param int empresa Id de la empresa consultada
 */
export async function guardaTarjetasEmergencia({commit, state, rootState}, empresa) {
  if (!state.selectedTarjetasEmergencia.encabezado_pie_pagina) {
    state.selectedTarjetasEmergencia.encabezado = '';
    state.selectedTarjetasEmergencia.pie_pagina = '';
  }
  if (!state.selectedTarjetasEmergencia.editar) {
    await $http.post(`empresas/modelo_te/crear/${empresa}`, state.selectedTarjetasEmergencia)
      .then((response) => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        state.error = false;
        state.selectedTarjetasEmergencia.editar = true;
      })
      .catch((error) => {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error.message,
          showConfirmButton: false,
          timer: 2000
        });
      });
  } else {
    await $http.put(`empresas/modelo_te/editar/${empresa}`, state.selectedTarjetasEmergencia)
      .then((response) => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
        state.error = false;
      })
      .catch((error) => {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error.message,
          showConfirmButton: false,
          timer: 2000
        });
      });
  }
}
